import { render, staticRenderFns } from "./GetQuotes.vue?vue&type=template&id=ced77f6a&"
import script from "./GetQuotes.vue?vue&type=script&lang=js&"
export * from "./GetQuotes.vue?vue&type=script&lang=js&"
import style0 from "./GetQuotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports